const Ellipse2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="543"
      height="525"
      viewBox="0 0 543 525"
      fill="none"
    >
      <g filter="url(#filter0_f_21_14)">
        <circle cx="118" cy="425" r="225" fill="#2D061B" fill-opacity="0.7" />
      </g>
      <defs>
        <filter
          id="filter0_f_21_14"
          x="-307"
          y="0"
          width="850"
          height="850"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_21_14"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Ellipse2;
